import connectToStores from 'alt-utils/lib/connectToStores'
import { SEOSettingsActions, SERPPreviewActions } from 'actions'
import { SEOSettingsStore, SERPPreviewStore } from 'stores'
import Helmet from 'react-helmet'
import { Nav, Loading, SERPPreview, Button, SupportForm, HelpEmail, FixedTemplate, CustomTemplate, InstallButton } from 'components'
import TextField from 'material-ui/TextField'
import { AnalyticsUtils, TemplateUtils, Enum } from 'utils'
import { ResponsiveDialog } from 'common-frontend'
import { SUPPORT_URL } from 'consts'

import './editTitleDescriptionTemplate.scss'

export default class EditTitleDescriptionTemplate extends React.Component {
  static propTypes = {
    params:           React.PropTypes.object.isRequired,
    settings:         React.PropTypes.object.isRequired,
    fetching:         React.PropTypes.bool,
    previews:         React.PropTypes.array,
    fetchingPreviews: React.PropTypes.bool,
    installed:        React.PropTypes.bool.isRequired,
    status:           React.PropTypes.object.isRequired,
    handleRequestInstall: React.PropTypes.func.isRequired,
    currentUser:      React.PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    const resourceName = props.params.resource[0].toUpperCase() + props.params.resource.substr(1)
    const ptTemplateName = `pageTitle${resourceName}Template`
    const mdTemplateName = `metaDescription${resourceName}Template`
    this.state = {

      url: null,
      enteredPreviewingUrl: null,
      previewingUrl: false,
      showUrlDialog: false,

      resourceName,
      ptTemplateName,
      mdTemplateName,
      pageTitleTemplate: null,
      metaDescriptionTemplate: null,

      pageTitleCustomMode: null,
      pageTitleTemplateVariables: null,
      metaDescriptionCustomMode: null,
      metaDescriptionTemplateVariables: null,
    }

    this.state.pageTitleTemplate = props.settings[ptTemplateName]
    this.state.metaDescriptionTemplate =  props.settings[mdTemplateName]

    if (resourceName !== 'Default' && resourceName !== '404') {
      SERPPreviewActions.fetchShopify(resourceName, 10, 0)
    }
  }

  componentWillMount() {
    this.initTemplateUI()
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.pageTitleTemplate === null && nextProps.settings) {
      let ptt = nextProps.settings[this.state.ptTemplateName] ? nextProps.settings[this.state.ptTemplateName] : ''
      this.setState({
        pageTitleTemplate: ptt
      })
    }

    if (this.state.metaDescriptionTemplate === null && nextProps.settings) {
      let mdt = nextProps.settings[this.state.mdTemplateName] ? nextProps.settings[this.state.mdTemplateName] : ''
      this.setState({
        metaDescriptionTemplate: mdt
      })
    }

    if (nextProps.showUrlDialog === true && this.props.showUrlDialog == false) {
      this.setState({
        enteredPreviewingUrl: this.state.url !== null ? this.state.url
          : this.state.enteredPreviewingUrl !== null ? this.state.enteredPreviewingUrl
          : ''
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching === true && this.props.fetching === false
        && this.state.resourceName !== 'Default' && this.state.resourceName !== '404') {
      if (this.state.previewingUrl === true) {
        SERPPreviewActions.fetch(this.state.url)
      } else {
        SERPPreviewActions.fetchShopify(this.state.resourceName, 10, 0)
      }
    }
  }

  initTemplateUI() {
    const { resourceName, pageTitleTemplate, metaDescriptionTemplate } = this.state
    let pageTitleCustomMode, metaDescriptionCustomMode, pageTitleTemplateVariables, metaDescriptionTemplateVariables

    if (resourceName === 'Index') {
      this.setState({
        pageTitleCustomMode: true,
        metaDescriptionCustomMode: true,
      })

      return
    }
    
    pageTitleTemplateVariables = TemplateUtils.deduceTemplateVariables(
      Enum.TitleTemplateFormula[resourceName],
      pageTitleTemplate
    )
    pageTitleCustomMode = !pageTitleTemplateVariables

    metaDescriptionTemplateVariables = TemplateUtils.deduceTemplateVariables(
      Enum.DescriptionTemplateFormula[resourceName],
      metaDescriptionTemplate
    )
    metaDescriptionCustomMode = !metaDescriptionTemplateVariables

    const stateChanges = {
      pageTitleCustomMode,
      metaDescriptionCustomMode,
      pageTitleTemplateVariables: pageTitleTemplateVariables || {},
      metaDescriptionTemplateVariables: metaDescriptionTemplateVariables || {},
    }

    if (!pageTitleCustomMode) stateChanges.pageTitleTemplate = ''
    if (!metaDescriptionCustomMode) stateChanges.metaDescriptionTemplate = ''

    this.setState(stateChanges)
  }

  save() {
    const {
      resourceName,
      pageTitleCustomMode,
      metaDescriptionCustomMode,
      pageTitleTemplate,
      metaDescriptionTemplate,
      pageTitleTemplateVariables,
      metaDescriptionTemplateVariables,
      ptTemplateName,
      mdTemplateName,
    } = this.state

    const {
      TitleTemplateFormula,
      DescriptionTemplateFormula,
    } = Enum

    // Generate template strings
    let settings = {}
    settings[ptTemplateName] = pageTitleCustomMode ?
      pageTitleTemplate :
      TemplateUtils.generateTemplate(TitleTemplateFormula[resourceName], pageTitleTemplateVariables)
    settings[mdTemplateName] = metaDescriptionCustomMode ?
      metaDescriptionTemplate :
      TemplateUtils.generateTemplate(DescriptionTemplateFormula[resourceName], metaDescriptionTemplateVariables)

    // Save data
    SEOSettingsActions.update(settings)
    AnalyticsUtils.templateUpdated(this.props.currentUser.email,
                                   settings[ptTemplateName],
                                   settings[mdTemplateName],
                                   pageTitleCustomMode ? 'custom' : 'recommended',
                                   metaDescriptionCustomMode ? 'custom' : 'recommended')

    // Clear opposite mode UIs (when custom, clear recommended; when recommended, clear custom)
    const stateChanges = {}
    if (pageTitleCustomMode) {
      stateChanges.pageTitleTemplateVariables = {}
    } else {
      stateChanges.pageTitleTemplate = ''
    }

    if (metaDescriptionCustomMode) {
      stateChanges.metaDescriptionTemplateVariables = {}
    } else {
      stateChanges.metaDescriptionTemplate = ''
    }

    this.setState(stateChanges)
  }

  onPreviewUrlChange(e) {
    this.setState({ enteredPreviewingUrl: e.target.value })
  }

  onPreviewUrlChanged() {
    SERPPreviewActions.fetch(this.state.enteredPreviewingUrl)
    this.setState({
      url                   : this.state.enteredPreviewingUrl,
      previewingUrl         : true,
      showUrlDialog         : false
    })
  }

  onPreview10() {
    SERPPreviewActions.fetchShopify(this.state.resourceName, 10, 0)
    this.setState({
      previewingUrl         : false,
      showUrlDialog         : false
    })
  }

  installPromptRequestStatus() {
    const requestStatus = this.props.status.installRequestStatus
    console.log(requestStatus)

    if (["requestedViaEmail", "requestedViaAnalytic"].includes(requestStatus)) {
      return (
        <div>
          <h5 className="small-spacing2--top medium-spacing--bottom seosettings__install-notice-status">Status: Manual Install Pending</h5>
          <p className="body2">Already installed? Contact <HelpEmail /></p>
        </div>
      )
    } else if (requestStatus == "self") {
      return (
        <div>
          <h5 className="small-spacing2--top large-spacing--bottom seosettings__install-notice-status">Status: Manual Code Not Installed</h5>
          <p>
          <h5 className="medium-spacing2--bottom">Want help installing?</h5>
            <Button
              label="Yes, Install the code for me"
              buttonType="primary"
              onTouchTap={this.props.handleRequestInstall}
            />
          </p>
        </div>
      )
    }

    return null
  }

  installPrompt() {
    return (
      <div className="seosettings__install-notice">
        <h3 className="small-spacing--bottom">Plug in SEO is not installed in your theme</h3>
        <p className="body2 medium-spacing2--bottom">Plug in SEO will not be able to generate page titles and descriptions until the code is installed.</p>
        { ::this.installPromptRequestStatus() ||
            <InstallButton
              label={this.props.isInstalling && "Installing…" || "Install Now"}
              buttonType="primary"
              disabled={this.props.isInstalling}
              status={this.props.status}
              currentUser={this.props.currentUser}
            />
        }
      </div>
    )
  }

  handleClickRecommendedTemplates() {
    AnalyticsUtils.viewedRecommendedTemplates()
  }

  handleTemplateModeToggle(scope) {
    const modeVariableName = `${scope}CustomMode`

    if (this.state[modeVariableName] === false) {
      AnalyticsUtils.customTemplateSelected(this.props.currentUser.email, scope === 'pageTitle' ? 'title' : 'description')
    }

    this.setState({
      [modeVariableName]: !this.state[modeVariableName],
    })
  }

  renderTitleTemplate(resourceName, friendlyName) {
    const { pageTitleCustomMode, pageTitleTemplateVariables, pageTitleTemplate } = this.state
    const {
      TitleTemplateChecklist,
      TitleTemplateFormula,
      CustomTemplateLearnLink,
      CustomTemplateExampleLinks,
    } = Enum

    const customTemplateProps = {
      checklist: [
        { text: 'Create a custom page title template using liquid code', condition: 'template', critical: true },
      ],
      helpLinks: [
        { label: 'View example templates', link: CustomTemplateExampleLinks[resourceName] },
        { label: 'Learn about using liquid code', link: CustomTemplateLearnLink },
      ],
    }
    // Special treatment for Home
    if (resourceName === 'Index') {
      customTemplateProps.checklist = TitleTemplateChecklist[resourceName]
      customTemplateProps.hintText = TitleTemplateFormula[resourceName]
    }

    return (
      <div className="seosettings__template--title">
        <h2 className="small-spacing2--bottom">Title Template</h2>
        {this.renderTemplateModeToggle(resourceName, 'pageTitle')}
        {!pageTitleCustomMode &&
          <FixedTemplate
            checklist={TitleTemplateChecklist[resourceName]}
            formula={TitleTemplateFormula[resourceName]}
            variables={pageTitleTemplateVariables}
            onChange={pageTitleTemplateVariables => this.setState({ pageTitleTemplateVariables })}
            onInstructionView={() => AnalyticsUtils.templateInstructionsViewed(this.props.currentUser.email, 'title')}
          />
        }
        {pageTitleCustomMode &&
          <CustomTemplate
            type="title"
            template={pageTitleTemplate}
            onChange={pageTitleTemplate => this.setState({ pageTitleTemplate })}
            onInstructionView={() => AnalyticsUtils.templateInstructionsViewed(this.props.currentUser.email, 'title')}
            {...customTemplateProps}
          />
        }
      </div>
    )
  }

  renderDescriptionTemplate(resourceName, friendlyName) {
    const { metaDescriptionCustomMode, metaDescriptionTemplateVariables, metaDescriptionTemplate } = this.state
    const {
      DescriptionTemplateChecklist,
      DescriptionTemplateFormula,
      CustomTemplateLearnLink,
      CustomTemplateExampleLinks,
    } = Enum

    const customTemplateProps = {
      checklist: [
        { text: 'Create a custom meta description template using liquid code', condition: 'template', critical: true },
      ],
      helpLinks: [
        { label: 'View example templates', link: CustomTemplateExampleLinks[resourceName] },
        { label: 'Learn about using liquid code', link: CustomTemplateLearnLink },
      ],
    }
    // Special treatment for Home
    if (resourceName === 'Index') {
      customTemplateProps.checklist = DescriptionTemplateChecklist[resourceName]
      customTemplateProps.hintText = DescriptionTemplateFormula[resourceName]
    }

    return (
      <div className="seosettings__template--description">
        <h2 className="small-spacing--bottom">Description Template</h2>
        {this.renderTemplateModeToggle(resourceName, 'metaDescription')}
        {!metaDescriptionCustomMode &&
          <FixedTemplate
            checklist={DescriptionTemplateChecklist[resourceName]}
            formula={DescriptionTemplateFormula[resourceName]}
            variables={metaDescriptionTemplateVariables}
            onChange={metaDescriptionTemplateVariables => this.setState({ metaDescriptionTemplateVariables })}
            onInstructionView={() => AnalyticsUtils.templateInstructionsViewed(this.props.currentUser.email, 'description')}
          />
        }
        {metaDescriptionCustomMode &&
          <CustomTemplate
            type="description"
            template={metaDescriptionTemplate}
            onChange={metaDescriptionTemplate => this.setState({ metaDescriptionTemplate })}
            onInstructionView={() => AnalyticsUtils.templateInstructionsViewed(this.props.currentUser.email, 'description')}
            {...customTemplateProps}
          />
        }
      </div>
    )
  }

  renderTemplateModeToggle(resourceName, scope) {
    if (resourceName === 'Index') return null
    const isCustomMode = this.state[`${scope}CustomMode`]

    return (
      <div className="seosettings__switch">
        <span className="seosettings__switch-container">
          <span
            className={`seosettings__switch-option seosettings__switch-option__recommended ${isCustomMode ? 'deselected' : 'selected'}`}
            onClick={() => isCustomMode && this.handleTemplateModeToggle(scope)}
          >Recommended</span>
          <span
            className={`seosettings__switch-option seosettings__switch-option__custom ${isCustomMode ? 'selected' : 'deselected'}`}
            onClick={() => !isCustomMode && this.handleTemplateModeToggle(scope)}
          >Custom</span>
        </span>
      </div>  
    )
  }

  render() {
    const label = this.props.fetching === true ? 'Saving...' : 'Save & Preview'
    const friendlyName = this.state.resourceName === 'Index' ? 'Homepage' : this.state.resourceName

    if (this.state.pageTitleTemplate === null || this.state.metaDescriptionTemplate === null) {
      return (
        <div>
          <Helmet title={`${friendlyName} SEO - Plug in SEO Plus`} />
          <Nav toolbarTitleText={`${friendlyName}`} />
          <Loading />
        </div>
      )
    }

    let previews = <Loading />
    if (this.props.previews !== null && this.props.fetchingPreviews === false
        && this.state.resourceName !== 'Default' && this.state.resourceName !== '404') {
      previews = []
      for (let preview of this.props.previews) {
        previews.push(
          <SERPPreview key={preview.url} embeddedInTemplateEditor={true} {...preview} />
        )
      }
    } else if (this.state.resourceName === 'Default' || this.state.resourceName === '404') {
      previews = null
    }

    let helpUrl = null
    switch (this.state.resourceName) {
      case 'Product':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534781904148-How-do-I-customise-my-product-title-and-description-templates'
        break
      case 'Collection':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534793842452-How-do-I-customise-my-collection-title-and-description-templates'
        break
      case 'Search':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534846199316-How-do-I-customise-my-search-title-and-description-templates'
        break
      case 'Blog':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534849616532-How-do-I-customise-my-blog-title-and-description-templates'
        break
      case 'Article':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534854618260-How-do-I-customise-my-article-title-and-description-templates'
        break
      case 'Page':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534814631188-How-do-I-customise-my-pages-title-and-description-templates'
        break
      case 'Default':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534783235348-How-do-I-customise-my-default-title-and-description-templates'
        break
      case 'Index':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534793211668-How-do-I-write-a-strong-homepage-title-and-description'
        break
      case '404':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534823336852-How-do-I-customise-my-404-title-and-description-templates'
        break
      case 'Catalog':
        helpUrl = 'https://support.pluginuseful.com/hc/en-us/articles/23534869558164-How-do-I-customise-my-catalog-title-and-description-templates'
        break
    }

    return (
      <div>
        <Helmet title={`${friendlyName} SEO - Plug in SEO Plus`} />
        <Nav toolbarTitleText={`${friendlyName} Templates`} />
        <div className='seosettings'>
          <div className="seosettings__form-container">
            {this.renderTitleTemplate(this.state.resourceName, friendlyName)}
            {this.renderDescriptionTemplate(this.state.resourceName, friendlyName)}
            {/* <a onTouchTap={::this.handleClickRecommendedTemplates}
               href={helpUrl}
               target='_blank'
               className="body2">
               Recommended Templates
            </a>
            <TextField floatingLabelText={`Title Template`}
              fullWidth={true}
              value={this.state.pageTitleTemplate}
              disabled={this.props.fetching}
              onChange={(e) => { this.setState({pageTitleTemplate: e.target.value}) }}
              className="spacing__large"
            /> */}
            {/* <h4>{friendlyName} Page Description Template</h4>
            <TextField floatingLabelText={`Description Template`}
              fullWidth={true}
              value={this.state.metaDescriptionTemplate}
              disabled={this.props.fetching}
              multiLine={true}
              onChange={(e) => { this.setState({metaDescriptionTemplate: e.target.value}) }}
              className="large-spacing--bottom"
            /> */}
            <Button
              label={label}
              buttonType="primary"
              disabled={this.props.fetching}
              onTouchTap={::this.save}
            />
          </div>
          <div className="seosettings__feedback-container">
            <SupportForm
              href={SUPPORT_URL}
              featureType="templates"
              featureKey={`templates_${this.props.params.resource}`}
            />
          </div>
          <div className="seosettings__preview-container">
          { previews !== null &&
            <div className='seosettings__row'>
              <h2 className="small-spacing--bottom">Live Search Engine Preview</h2>
              {
                this.state.previewingUrl === true &&
                <p className="medium-spacing--bottom body2">
                  <a onTouchTap={::this.onPreview10}>Preview 10</a> | Previewing URL: <a onTouchTap={ () => { this.setState({ showUrlDialog: true }) } }>{ this.state.url }</a>
                </p>
              }
              {
                this.state.previewingUrl === false &&
                <p className="medium-spacing--bottom body2">
                  Previewing up to 10 | <a onTouchTap={ () => { this.setState({ showUrlDialog: true }) } }>Preview a URL</a>
                </p>
              }
              {this.props.installed && previews || ::this.installPrompt() }
            </div>
          }
          </div>
        </div>
        <ResponsiveDialog
          title='Preview a URL'
          modal={true}
          open={this.state.showUrlDialog}
          onRequestClose={() => this.setState({ showUrlDialog: false })}
        >
          <div>
            <TextField floatingLabelText='URL to preview' fullWidth={true}
              value={this.state.enteredPreviewingUrl !== null ? this.state.enteredPreviewingUrl : ''}
              onChange={::this.onPreviewUrlChange}
              className="large-spacing--bottom"
            />
            <Button
              label='Preview'
              buttonType="primary"
              onTouchTap={::this.onPreviewUrlChanged}
            />
            <Button
              label='Cancel'
              buttonType="secondary"
              className="secondary-btn"
              onTouchTap={() => {
                this.setState({
                  showUrlDialog       : false
                })}
              }
            />
          </div>
        </ResponsiveDialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/EditTitleDescriptionTemplate.js